import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from "@angular/router";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../../shared/redux-store/store";
import {Observable} from "rxjs/Observable";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {LOGIN_TO_TOUCH_CLIENT} from "../../../../shared/auth/guards/api-permission";

@Injectable()
export class TouchAuthorizedGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router, private siActions: SessionActions, private ngRx: NgRedux<IAppState>) {

  }

  canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    let loggedIn = false;

    try {
      loggedIn = this.ngRx.getState().session.loggedIn && this.ngRx.getState().session.user.permissions.indexOf(LOGIN_TO_TOUCH_CLIENT) >= 0;
    } catch (e) {
      console.error(e);
    }

    if (!loggedIn) {
      this.redirectToLogin(state);
    }

    return loggedIn;

  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(childRoute, state);
  }

  private redirectToLogin(state: RouterStateSnapshot): boolean {
    this.siActions.setRedirectUrl(null);
    this.router.navigate(['/login']);
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/authorization/guards/touch-authorized.guard.ts